import PaymentRequestsTableColumnActions from './index.vue'
export default PaymentRequestsTableColumnActions